
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
/* import { Select } from "antd"; */
import Modal from "react-bootstrap/Modal";


const Select2 = ({ name, label, options, error, optionsCompanyUsers, ...rest }) => {
  
      const [showModal, setShowModal] = useState(false);
      const [selectedClient, setSelectedClient] = useState(null);
      const [inputClient, setInputClient] = useState(null);
  
const handleInformation = () => {
      const input = document.getElementById(name);
      const rawInput = input ? input.value.trim() : "";
      console.log(optionsCompanyUsers);

        if (!rawInput) {
          alert("No input value found.");
          return;
        }

        const selectedValue = rawInput.toLowerCase();

        const client = (optionsCompanyUsers || []).find(user =>
          (user.email && user.email.toLowerCase() === selectedValue) ||
          (user.username && user.username.toLowerCase() === selectedValue) ||
          (user.firstName && user.firstName.toLowerCase() === selectedValue) ||
          (user.lastName && user.lastName.toLowerCase() === selectedValue) ||
          (`${user.firstName || ""} ${user.lastName || ""}`.toLowerCase() === selectedValue) ||
          (user.name && user.name.toLowerCase() === selectedValue)
        );

        if (client) {
          setSelectedClient(client);
          setShowModal(true);
        } else {
          alert("Please select a valid option to continue");
        }
      };

 
const handleClose = () => {
      setShowModal(false);
      setSelectedClient(null);
      setInputClient(null); 
    };

const handleInputChange = (e) => {
    const selectedValue = e.target.value.toLowerCase().trim();
    

    const client = (optionsCompanyUsers || []).find(user =>
      user.email && user.email.toLowerCase() === selectedValue ||
      user.username && user.username.toLowerCase() === selectedValue ||
      user.firstName && user.firstName.toLowerCase() === selectedValue ||
      user.lastName && user.lastName.toLowerCase() === selectedValue ||
      `${user.firstName} ${user.lastName}`.toLowerCase() === selectedValue ||
      user.name && user.name.toLowerCase() === selectedValue
    );


    if (client) {
      const fullName = `${client.firstName} ${client.lastName}`.trim();
      
    
      if (e.target.value !== fullName) {
        e.target.value = fullName;
      }

    setSelectedClient(client);
    setInputClient(client);
      }
    }
    

 return (
<div>
  <label className="formLabel" htmlFor={name}>
    {label}
  </label>

  <input
    list={`datalist-${name}`}
    name={name}
    id={name}
    className="form-control2" onInput={handleInputChange}
    {...rest}
  />

  <datalist id={`datalist-${name}`}>
    {(options || []).map((option) => (
      <option key={option.username} value={option.name} />
    ))}
  </datalist> 
    {error && <div className="alert alert-danger">{error}</div>}
  <span onClick={handleInformation} style={{ cursor: "pointer" }}>

    <FontAwesomeIcon
      icon={faCircleInfo}
      style={{
        fontSize: "15px",
        color: "#007bff",
        marginLeft: "5px",
      }}
    />
  </span>
      {showModal && selectedClient && (
        <Modal
          show={showModal}
          onHide={handleClose}
          size="m"
          backdrop="static"
          keyboard={false}
          centered
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Customer Information</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ color: "white" }}>
          <h6 style={{ color: "#ffc000" }}>Name:</h6>
          <p style={{ color: "black" }}>{selectedClient.firstName || "N/A"}</p>

          <h6 style={{ color: "#ffc000" }} >Last Name:</h6>
          <p style={{ color: "black" }}>{selectedClient.lastName || "N/A"}</p>

          <h6 style={{ color: "#ffc000" }} >Username:</h6>
          <p style={{ color: "black" }}>{selectedClient.username || "N/A"}</p>

          <h6 style={{ color: "#ffc000" }} >Email:</h6>
          <p style={{ color: "black" }}>
            {selectedClient.email || selectedClient.name || "N/A"}
          </p>
           <h6 style={{ color: "#ffc000" }} >Phone Number:</h6>
          <p style={{ color: "black" }}>{selectedClient.phoneNumber || "N/A"}</p>

        </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
  </div>
  );
}; 




export default Select2;